import { getAxiosClient } from 'api';

export const getPrefectureJp = () => {
    const restClient = getAxiosClient();
    return restClient.get('/resources/prefectures');
};
